import React, { ReactNode } from 'react'

export default function Title({ children, size, customClassName }: { children: ReactNode, size?: string, customClassName?: string }) {
    return (
        <div className={`font-bold ${size ? `${size}` : "text-xl"} ${customClassName} font-[Oswald,sans-serif] capitalize`}>{children}</div>
    )
}